import React, { Component } from "react";
import Header from "./common/Header";
import Sidebar from "./common/Sidebar";

import { Link } from "react-router-dom";

import {CopyToClipboard} from 'react-copy-to-clipboard';

import NumberFormat from 'react-number-format';

import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";

export class Referrals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage["appState"]
        ? JSON.parse(localStorage["appState"]).user.token
        : "",
      user: [],
      user_referrals: [],
      user_earnings: [],
      total_earnings: "",
      isLoading: true,
      copied: false,
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser() {
    axios
      .get(
        `${axios.defaults.baseURL}/user/${
          JSON.parse(localStorage["appState"]).user.id
        }`,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({
            user: json.data.user[0],
            user_referrals: json.data.user_referrals,
            user_earnings: json.data.user_earnings,
            total_earnings: json.data.total_earnings,
            isLoading: false,
          });
          // } else alert("Cannot Fetch Data!");
        } else swal("Oops!", "Cannot Fetch Data!", "error");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
    // alert(id)
  }

  requestPayment(id) {

    axios({
        method: 'get',
        url: `${axios.defaults.baseURL}/request-ref-payment/${id}`
        })
      .then((response) => {
        //console.log(response);
        return response;
      });
      this.getUser();
  };

  render() {
    return (
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div className="page-title">
                    <div className="row text-primary py-2 pt-4">
                      <div className="col-10">
                        <div
                          className="user-welcome"
                          style={{ overflow: "hidden" }}
                        >
                          <div className="wrapper d-flex">
                            <h4 className="d-inline-block">My Referrals</h4>
                          </div>
                        </div>
                      </div>
                      <div className="text-right col-2"></div>
                    </div>
                  </div>
                  <>
                    <div>
                      <div
                        data-v-c3744dc0=""
                        class="wrapper p-4 bg-primary dash-card shadow-2xl"
                      >
                        <div data-v-c3744dc0="" class="row">
                          <div data-v-c3744dc0="" class="col-12">
                            <h3 data-v-c3744dc0="" class="text-white">
                              Your Referral Link
                            </h3>
                            <br />
                            <div data-v-c3744dc0="" class="d-inline">
                              <div data-v-c3744dc0="">
                                {/* <span
                                    tabindex="0"
                                    data-link="#share-facebook"
                                    class="d-inline-block  mb-2"
                                  >
                                    <button
                                      type="button"
                                      class="btn btn-primary btn-sm"
                                    >
                                      <i class="fab fa-facebook icon-fx"></i>
                                    </button>
                                  </span>
                                  <span
                                    tabindex="0"
                                    data-link="#share-twitter"
                                    class="d-inline-block  mb-2"
                                  >
                                    <button
                                      type="button"
                                      class="btn btn-primary btn-sm"
                                    >
                                      <i class="fab fa-twitter icon-fx"></i>
                                    </button>
                                  </span>
                                  <span
                                    tabindex="0"
                                    data-link="#share-whatsapp"
                                    class="d-inline-block  mb-2"
                                  >
                                    <button
                                      type="button"
                                      class="btn btn-primary btn-sm"
                                    >
                                      <i class="fab fa-whatsapp icon-fx"></i>
                                    </button>
                                  </span> 
                                  <span
                                    tabindex="0"
                                    data-link="#share-linkedin"
                                    class="d-inline-block  mb-2"
                                  >
                                    <button
                                      type="button"
                                      class="btn btn-primary btn-sm"
                                    >
                                      <i class="fab fa-linkedin icon-fx"></i>
                                    </button>
                                  </span>*/}
                              </div>
                            </div>
                            <p data-v-c3744dc0="" class="text-white">
                              {" "}
                              Share with Friends and Family and Earn 5% when
                              your referrals activate an Evest or Landvest Plan.
                            </p>
                            <div
                              data-v-c3744dc0=""
                              role="group"
                              class="input-group"
                            >
                              <input
                                data-v-c3744dc0=""
                                id="ref-link"
                                value={this.state.user.ref_link}
                                onChange={({target: {value}}) => this.setState({value, copied: false})}
                                type="text"
                                class="form-control"
                                disabled=""
                                style={{textTransform:"lowercase"}}
                              />
                              <div
                                data-v-c3744dc0=""
                                class="input-group-append"
                              >
                                  <CopyToClipboard text={this.state.user.ref_link}
                                onCopy={() => this.setState({copied: true})}>
                                <button
                                  data-v-c3744dc0=""
                                  type="button"
                                  class="btn btn-secondary"
                                  style={{ backgroundColor: "#000000" }}
                                >
                                  Copy
                                </button>
                                </CopyToClipboard>
                              </div>
                            </div>
                                <br/>
                              {this.state.copied ? <span style={{color: 'white'}}>Referral Link has been Copied!</span> : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                  <table class="mt-4 table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">Your Earnings</th>
                      </tr>
                    </thead>
                  </table>
                  {this.state.isLoading ? (
                    <div
                      data-v-22924209=""
                      class="dash-card-plan bg-white"
                    >
                      <div className="dash-card-main bg-cover blink_me text-center">
                        <br />
                        Loading...
                        <br />
                        <br />
                      </div>
                    </div>
                  ) : (
                    <>
                      {this.state.user_earnings != "" ? (
                        <div className="align-items-stretch">
                          <table class="table">
                            <tbody>
                              {this.state.user_earnings.map((earning, index) => (
                                <tr>
                                  <td>{earning.date}</td>
                                  <td><NumberFormat value={earning.commission} displayType={'text'} thousandSeparator={true} prefix={'₦'} /> </td>
                                  
                                  {earning.status == 1 ?
                                  <td>Paid</td>
                                  :earning.status == 2 ?
                                  <td>Payment Requested</td>
                                  : <td>
                                      <button
                                      className="text-primary"
                                      style={{background:"none", border:"none"}}
                                      onClick={this.requestPayment.bind(this, earning.id)}
                                      >
                                          Click to Request Payment
                                      </button>
                                  </td>
                                }
                                </tr>
                              ))}
                              <tr>
                                  <td><b>Total Earnings</b></td>
                                  <td><NumberFormat value={this.state.total_earnings} displayType={'text'} thousandSeparator={true} prefix={'₦'} /> </td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          data-v-22924209=""
                          class="empty-placeholder dash-card bg-white"
                        >
                          You have no earnings yet.
                        </div>
                      )}
                    </>
                  )}
                  <table class="mt-4 table">
                    <thead class="thead-dark">
                      <tr>
                        <th scope="col">Your Referrals</th>
                      </tr>
                    </thead>
                  </table>
                  {this.state.isLoading ? (
                    <div
                      data-v-22924209=""
                      class="dash-card-plan bg-white"
                    >
                      <div className="dash-card-main bg-cover blink_me text-center">
                        <br />
                        Loading...
                        <br />
                        <br />
                      </div>
                    </div>
                  ) : (
                    <>
                      {this.state.user_referrals != "" ? (
                        <div className="align-items-stretch">
                          <table class="table">
                            <tbody>
                              {this.state.user_referrals.map((user, index) => (
                                <tr>
                                  <td>{index+1}</td>
                                  <td>{user.fname}</td>
                                  <td>{user.lname}</td>
                                  <td>{user.email}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div
                          data-v-22924209=""
                          class="empty-placeholder dash-card bg-white"
                        >
                          You have no referrals yet.
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Referrals;
